import type * as monaco from 'monaco-editor'

export const FPlusDefaultFormattingWidth = 120

export const FPlusDefaultFontWidth = 6.56
export const FPlusEditorOptions: monaco.editor.IStandaloneEditorConstructionOptions =
  {
    autoIndent: 'full',
    lineNumbers: 'on',
    readOnly: false,
    glyphMargin: false,
    overviewRulerLanes: 0,
    hideCursorInOverviewRuler: true,
    minimap: { enabled: false },
    folding: true,
    foldingStrategy: 'indentation',
    showFoldingControls: 'always',
    suggest: {
      preview: true,
      previewMode: 'subwordSmart',
    },
    hover: {
      delay: 600,
    },
    lineDecorationsWidth: 15,
    lineHeight: 14,
    suggestLineHeight: 20,
    suggestFontSize: 13,
    fontLigatures: "'zero'", // Matches the features the font-mono utility applies to the viewers
    fontSize: 12,
    fontFamily: "'Paper Mono Variable', 'ui-monospace', 'monospace'",
  }
